export default 
[
  {
    id: 0,
    nome: 'Depósito'
  },
  {
    id: 1,
    nome: 'Cheque'
  },
  {
    id: 2,
    nome: 'Ordem de pagamento'
  },
  {
    id: 3,
    nome: 'Boleto'
  },
]



// WEBPACK FOOTER //
// ./FrontEnd/js/formas-pagamento.js